// import React from "react";

// export default function SocialHandles({ style, label, socialIcons, iconStyles }) {
//     return (
//         <div style={style}>
//             {socialIcons.map((icon, index) => {
//                 if (icon.url !== '#') {

//                     const StyledIcon = React.cloneElement(icon.icon, {
//                         style: iconStyles,
//                     });

//                     return (
//                         <span key={index}>
//                             <a href={icon.url}>
//                                 {StyledIcon}
//                             </a>
//                         </span>
//                     );
//                 }
//                 return null;
//             })}
//         </div>
//     );
// }


// export default function SocialHandles({ style, socialIcons, outerStyle }) {
//     return (
//         <div style={style}>
//             {socialIcons.map((icon, index) => {
//                   return  ((icon.url !== '') && 
//                             <a 
//                                 href={icon.url}
//                                 style={{
//                                     display: 'inline-flex',
//                                     textDecoration: 'none'
//                                 }}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                             >
//                                 <img src={icon.iconImage} alt={icon.name} style={outerStyle}/>
//                             </a>)
//             })}
//         </div>
//     );
// };


export default function SocialHandles({ style, socialIcons, outerStyle }) {
  return (
    <table
      role="presentation"
      width="100%"
      cellSpacing="0"
      cellPadding="0"
      style={{ width: "100%", backgroundColor: style?.backgroundColor }}
    >
      <tr>
        <td align={style?.align} valign="middle" style={{ padding: style?.padding || "0" }}>
          {/* Icons displayed inline-block so they wrap automatically */}
          {socialIcons.map((icon, index) =>
            icon.url ? (
              <a
                key={index}
                href={icon.url}
                target="_blank"
                style={{
                  display: "inline-block",
                  textDecoration: "none",
                  marginRight: style?.marginRight, // "gap" replacement
                  marginBottom: style?.marginBottom,
                }}
              >
                <img
                  src={icon.iconImage}
                  alt={icon.name}
                  style={{
                    width: outerStyle?.width,
                    height: "auto",
                    display: "block",
                  }}
                />
              </a>
            ) : null
          )}
        </td>
      </tr>
    </table>
  );
}
